const tooltipActionExpPanel = {
  title: 'Generar nueva acción'
};

export default tooltipActionExpPanel;
